import React, { useState } from "react";
import './RequestToolbar.css';

export function RequestToolbar({ leftButtons, rightButtons }) {
  const [activeOption, setActiveOption] = useState(null);

  const toggleOption = (option) => {
    setActiveOption(activeOption === option ? null : option);
  };

  return (
    <div className="toolbar-container">
    <div className="toolbar-main">
      <div className="toolbar-left">{leftButtons}</div>
      <div className="toolbar-right">
        {rightButtons.map((button, index) => (
          <div key={index} onClick={() => toggleOption(index)}>
            {React.cloneElement(button, { isActive: activeOption === index })}
          </div>
        ))}
      </div>
    </div>

    {/* Ensure only buttons with optionsComponent are rendered below */}
    {activeOption !== null && rightButtons[activeOption].props.optionsComponent && (
      <div className="toolbar-options">
        {React.cloneElement(rightButtons[activeOption].props.optionsComponent, { setActiveOption })}
      </div>
    )}
  </div>
  );
};